import { AutoMap } from '@automapper/classes';

export class MesureAdductionEntity {
    Id?: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    Date!: string;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    SamplingID!: number;
    @AutoMap()
    Observation!: string;
    @AutoMap()
    AppareilMesure!: string;
    @AutoMap()
    IsCancelled: boolean = false;
    @AutoMap()
    Position!: number;
    
    /** 3 Max  */
    MaterielAdductionIds?: number[];

    /** 5 Max  */
    PrelevementAirIds?: number[];
}
